import { markToMarketSettingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MARKET_TO_MARKET_ACTION_TYPE = createNamedActions('marketToMarket', {
  GET_MARKET_TO_MARKET: 'GET_MARKET_TO_MARKET',
  UPDATE_MARKET_TO_MARKET: 'UPDATE_MARKET_TO_MARKET',
});

export const getMarketToMarketAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await markToMarketSettingApi.getSetting();

  return dispatch({
    type: MARKET_TO_MARKET_ACTION_TYPE.GET_MARKET_TO_MARKET,
    payload: data,
  });
});

export const updateMarketToMarketAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await markToMarketSettingApi.editSetting(params);

  return dispatch({
    type: MARKET_TO_MARKET_ACTION_TYPE.UPDATE_MARKET_TO_MARKET,
    payload: data,
  });
});
